import _ from 'lodash';

import produce, { Draft } from 'immer';

import { UploadStatus } from '@models';
import {
  IUploadsState,
  GETTING_UPLOADS,
  UploadsActionTypes,
  GOT_UPLOADS,
  UPLOADS_LOCAL_CHANGE,
  CANCELLED_UPLOAD,
  CANCELLING_UPLOAD,
  IUploadAction,
  REMOVING_UPLOAD,
  REMOVED_UPLOAD,
  IGotUploadsAction,
} from '@store/types/uploads/uploads';

import { RequestStatus } from '@store/types/request';

const initialState: IUploadsState = {
  status: RequestStatus.none,
  uploads: [],
  localChanges: 0,
};

export const uploadsReducer = produce(
  (state: Draft<IUploadsState>, action: UploadsActionTypes): void => {
    switch (action.type) {
      case GETTING_UPLOADS:
        state.status = RequestStatus.inProgress;
        break;
      case GOT_UPLOADS:
        state.status = RequestStatus.completed;
        state.uploads = (action as IGotUploadsAction).payload;
        break;
      case UPLOADS_LOCAL_CHANGE:
        state.localChanges += 1;
        break;
      case CANCELLED_UPLOAD:
        {
          const { id } = (action as IUploadAction).payload;
          state.uploads = _.reject(state.uploads, (q) => q.id === id);
          state.localChanges += 1;
        }
        break;
      case CANCELLING_UPLOAD:
        {
          const { id } = (action as IUploadAction).payload;
          const upload = _.find(state.uploads, (q) => q.id === id);
          if (upload) {
            upload.status = UploadStatus.uploadCancelling;
          }
        }
        break;
      case REMOVED_UPLOAD:
        {
          const { id } = (action as IUploadAction).payload;
          state.uploads = _.reject(state.uploads, (q) => q.id === id);
          state.localChanges += 1;
        }
        break;
      case REMOVING_UPLOAD:
        {
          const { id } = (action as IUploadAction).payload;
          const upload = _.find(state.uploads, (q) => q.id === id);
          if (upload) {
            upload.status = UploadStatus.uploadRemoving;
          }
        }
        break;
    }
  },
  initialState
);
